module.exports = __webpack_public_path__ + "static/media/undo.e20094b0.svg";